import React from 'react';
interface Props {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left'
}: Props) {
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-750" data-mp="1351aiavjdcg2">
      {eyebrow && <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-751" data-mp="y92q0ydbwekx">
          {eyebrow}
        </p>}
      <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-752" data-mp="5ikct4iw4wts">
        {title}
      </h2>
      {description && <p className="mt-4 text-[16px] leading-relaxed text-charcoal/70" data-id="element-753" data-mp="jfz6ilg6fqrk">
          {description}
        </p>}
    </div>;
}